import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router'
import { api } from '../api/client'
import type { Versorgungspunkt } from '../api/typen'
import AppRahmen from '../komponenten/AppRahmen'

/** Schritt 1: Versorgungspunkt anlegen (P1-01 bis P1-03). */
export default function VersorgungspunktNeu() {
  const { erfassungId } = useParams()
  const navigiere = useNavigate()

  const [bezeichnung, setBezeichnung] = useState('')
  const [anzahlSchraenke, setAnzahlSchraenke] = useState('')
  const [notiz, setNotiz] = useState('')

  const anlegen = useMutation({
    mutationFn: () =>
      api.post<Versorgungspunkt>(`/api/erfassungen/${erfassungId}/versorgungspunkte`, {
        bezeichnung,
        notiz: notiz.trim() === '' ? null : notiz,
        anzahlSchraenkeSoll: anzahlSchraenke === '' ? null : Number(anzahlSchraenke),
      }),
    onSuccess: (punkt) => navigiere(`/versorgungspunkte/${punkt.id}`),
  })

  return (
    <AppRahmen
      titel="Versorgungspunkt"
      unter="Schritt 1 von 3"
      zurueck={`/erfassungen/${erfassungId}`}
      fuss={
        <button
          className="btn btn-primaer"
          disabled={!bezeichnung.trim() || anlegen.isPending}
          onClick={() => anlegen.mutate()}
        >
          Weiter zu den Schränken
        </button>
      }
    >
      <div className="feld">
        <label className="label" htmlFor="bezeichnung">
          Bezeichnung oder Raum
        </label>
        <input
          id="bezeichnung"
          type="text"
          placeholder="z. B. Station 3B, Lager links"
          value={bezeichnung}
          onChange={(ereignis) => setBezeichnung(ereignis.target.value)}
        />
      </div>

      <div className="feld">
        <label className="label" htmlFor="anzahl">
          Anzahl Schränke (optional)
        </label>
        <input
          id="anzahl"
          type="number"
          inputMode="numeric"
          min={1}
          placeholder="kann auch später entstehen"
          value={anzahlSchraenke}
          onChange={(ereignis) => setAnzahlSchraenke(ereignis.target.value)}
        />
      </div>

      <div className="feld">
        <label className="label" htmlFor="notiz">
          Notiz (optional)
        </label>
        <textarea
          id="notiz"
          placeholder="Besonderheiten, Zugang, Ansprechpartner"
          value={notiz}
          onChange={(ereignis) => setNotiz(ereignis.target.value)}
        />
      </div>

      {anlegen.isError && <p className="hinweiszeile">{(anlegen.error as Error).message}</p>}
    </AppRahmen>
  )
}
